/**
 * O aparelho é um celular/tablet com câmera? Decide o que o ícone de
 * câmera da placa faz: abrir a câmera do próprio aparelho ou mostrar o QR
 * para o celular.
 *
 * Exige as três coisas juntas — toque como ponteiro principal, user agent
 * de celular/tablet e `mediaDevices` — para não confundir notebook com
 * tela touch (ponteiro fino) nem navegador de mesa emulando celular sem
 * câmera. No Electron dá `false` naturalmente (UA de desktop, mouse).
 */
export function ehDispositivoMovelComCamera(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;

  const toque =
    typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;
  if (!toque) return false;

  const ua = navigator.userAgent || '';
  const uaMovel = /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
  // iPadOS 13+ se apresenta como Mac; o que entrega é ter vários pontos de toque.
  const iPadComoMac = /Macintosh/i.test(ua) && (navigator.maxTouchPoints ?? 0) > 1;
  if (!uaMovel && !iPadComoMac) return false;

  return Boolean(navigator.mediaDevices);
}
